webpackJsonp([1],{

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------
// Imports
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.reviewsSlider = exports.firmsSlider = exports.mainSlider = undefined;

__webpack_require__(123);

// ----------------------------------------
// Private
// ----------------------------------------

var $mainSlider = $('.main-slider');
var $firmsSlider = $('.firms-slider');
var $reviewsSlider = $('.review-img-slider');

// ----------------------------------------
// Public
// ----------------------------------------

function mainSlider() {
	$mainSlider.slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 3000,
		infinite: true,
		dots: true,
		fade: true,
		appendDots: $('.main-slider__controls'),
		prevArrow: '<button type="button" class="slick-arrow slick-prev"></button>',
		nextArrow: '<button type="button" class="slick-arrow slick-next"></button>'
	});
}

function firmsSlider() {
	$firmsSlider.slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 3000,
		infinite: true,
		dots: true,
		fade: true,
		appendDots: $('.firms-slider__controls'),
		prevArrow: '<button type="button" class="slick-arrow slick-prev"></button>',
		nextArrow: '<button type="button" class="slick-arrow slick-next"></button>'
	});
}

function reviewsSlider() {
	$reviewsSlider.slick({
		slidesToShow: 2,
		slidesToScroll: 1,
		infinite: true,
		dots: false,
		vertical: true,
		prevArrow: '<button type="button" class="slick-arrow slick-prev"></button>',
		nextArrow: '<button type="button" class="slick-arrow slick-next"></button>',
		responsive: [{
			breakpoint: 1024,
			settings: {
				slidesToShow: 3,
				vertical: false
			}
		}, {
			breakpoint: 640,
			settings: {
				slidesToShow: 1
			}
		}]
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.mainSlider = mainSlider;
exports.firmsSlider = firmsSlider;
exports.reviewsSlider = reviewsSlider;

/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------
// Imports
// ----------------------------------------

// ----------------------------------------
// Private
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});
var $header = $('.header'),
    $scrollHeader = $('.header.scroll'),
    $headerTop = $('.header__top'),
    $wrapper = $('.wrapper'),
    $searchWrap = $('.header__search-wrap'),
    $searchBox = $('.header__search-hidden'),
    $searchButton = $('.header__search-btn'),
    $dropdown = $('.header__top-dropdown'),
    $dropdownBtn = $('.header__top-dropdown-btn'),
    $dropdownIcon = $('.header__lang-icon'),
    $dropdownWrap = $('.header__top-dropdown-wrap'),
    $headerSearchInput = $('.header__search-input');

// function toggleContent () {
// 	// $hide.removeClass('show');
// 	// $show.addClass('show');
//
// 	$('body').on('click', '.remind-password-toggle', function () {
// 		$('.login').removeClass('show');
// 		$('.remind-password').addClass('show');
// 	});
// }

// ----------------------------------------
// Public
// ----------------------------------------

function fixedHeader() {
	if ($(window).scrollTop() > 40 && !$scrollHeader.length) {
		$headerTop.slideUp('slow');
		$header.addClass('scroll');
	}

	if ($(window).scrollTop() === 0) {
		$headerTop.slideDown('fast');
		$header.removeClass('scroll');
	}
}

function headerSearch() {
	$searchButton.on('click', function () {
		if ($searchBox.hasClass('open')) {
			$searchBox.children('.js-form')[0].reset();
		}

		$(this).toggleClass('active');
		$searchWrap.toggleClass('open');
		$searchBox.toggleClass('open');
	});

	$('.header__search-input').keypress(function (event) {
		if (event.which === 13) {
			event.preventDefault();
			$(this).closest('.js-form').submit();
		}
	});

	$(document).click(function (e) {
		if (!$searchWrap.is(e.target) && $searchWrap.has(e.target).length === 0) {
			$searchBox.removeClass('open');
			$searchWrap.removeClass('open');
			$searchButton.removeClass('active');

			$searchBox.children('.js-form')[0].reset();
		}
	});
}

function setPaddingTop() {
	var $header = $('.header');
	var headerHeight = $header.outerHeight();

	$wrapper.css({ 'padding-top': headerHeight });
	$('.moonlight-top').css('height', headerHeight);

	// $('#textbox1').val(this.checked);

	$('#checkbox1').change(function () {
		if (this.checked) {
			console.log('checked');
		} else {
			console.log('unchecked');
		}
	});
}

function headerLang() {
	$dropdownBtn.on('click', function () {
		$dropdownWrap.toggleClass('open');
		$dropdown.slideToggle('fast');
		$dropdownIcon.toggleClass('open');
	});

	$(document).click(function (e) {
		if (!$dropdownWrap.is(e.target) && $dropdownWrap.has(e.target).length === 0) {
			$dropdown.slideUp('fast');
			$dropdownIcon.removeClass('open');
			$dropdownWrap.removeClass('open');
		}
	});
}

function loginToggle() {
	var $body = $('body');

	$body.on('click', '.remember-password', function () {
		$('.login-wrap').removeClass('show');
		$('.remember-wrap').addClass('show');
	});

	$body.on('click', '.login', function () {
		$('.remember-wrap').removeClass('show');
		$('.login-wrap').addClass('show');
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.fixedHeader = fixedHeader;
exports.headerSearch = headerSearch;
exports.setPaddingTop = setPaddingTop;
exports.headerLang = headerLang;
exports.loginToggle = loginToggle;

/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------
// Imports
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.filterMenu = exports.mobileMenu = undefined;

__webpack_require__(126);

// ----------------------------------------
// Private
// ----------------------------------------
var $icon = $('#mob-open');
var $filterBtn = $('.filter-mob');
var $filtersMenu = $('#mob-filters');

// ----------------------------------------
// Public
// ----------------------------------------

function mobileMenu() {
	var $menu = $('#mob-menu').mmenu({
		'extensions': ['pagedim-black', 'theme-white', 'fx-menu-slide']
	});

	var API = $menu.data('mmenu');

	$icon.on('click', function () {
		API.open();
	});

	API.bind('open:finish', function () {
		setTimeout(function () {
			$icon.addClass('is-active');
		}, 100);
	});
	API.bind('close:finish', function () {
		setTimeout(function () {
			$icon.removeClass('is-active');
		}, 100);
	});

	$('.header__menu').each(function () {
		if ($('.header__sub-menu-link').hasClass('active')) {
			var id = $('.header__sub-menu-link.active').attr('data-id');
			$('.header__menu-link[data-id="' + id + '"]').addClass('active');
		}
	});
}

function filterMenu() {
	var $menu = $filtersMenu.mmenu({
		navbar: {
			title: 'Filtr'
		},
		// "navbars": [
		// 	{
		// 		"position": "top",
		//
		// 		"content": [
		// 			"title",
		// 			"close"
		// 		]
		// 	}
		// ],
		'extensions': ['pagedim-black', 'theme-white', 'fx-menu-slide', 'border-none']
	});

	var API = $menu.data('mmenu');

	$filterBtn.on('click', function () {
		API.open();
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.mobileMenu = mobileMenu;
exports.filterMenu = filterMenu;

/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------
// Imports
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.spincrementNum = undefined;

__webpack_require__(128);

// ----------------------------------------
// Public
// ----------------------------------------

var show = true;
var $countBox = $('.spincrement-box');

function spincrementNum() {
	if (!$countBox.length) {
		return false;
	}

	if (!show) {
		return false;
	}

	$('.spincrement').spincrement({
		thousandSeparator: '',
		duration: 5000
	});

	show = false;
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.spincrementNum = spincrementNum;

/***/ }),

/***/ 129:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------
// Public
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});
function subMenuToggle(item, wrap, slide) {
	var $wrap;
	var $openWrap = $(wrap + '.open');
	var $this;

	if ($openWrap) {
		$openWrap.find(slide).slideDown('fast');
	}

	$(item).click(function (e) {
		e.preventDefault();

		$this = $(this);
		$wrap = $this.closest($(wrap));

		$wrap.find(slide).slideToggle('fast');
		$wrap.toggleClass('open');
		$this.toggleClass('open');
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.subMenuToggle = subMenuToggle;

/***/ }),

/***/ 130:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------
// Imports
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.initSelect = undefined;

__webpack_require__(131);

__webpack_require__(21);

// ----------------------------------------
// Public
// ----------------------------------------

function initSelect() {
	$('.select2').each(function (index) {
		var $this = $(this);

		$this.select2({
			minimumResultsForSearch: Infinity,
			dropdownParent: $this.closest('.select2-wrap'),
			placeholder: $this.data('placeholder'),
			width: 'resolve'
		});

		$this.on('select2:select', function () {
			var $form = $this.closest('.js-form');

			if ($form.length) {
				$form.validate().element($this);
			}
		});
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.initSelect = initSelect;

/***/ }),

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */

// ----------------------------------------
// Imports
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.initScrollbar = undefined;

__webpack_require__(133);

// ----------------------------------------
// Private
// ----------------------------------------

var $scrollbar = $('.table-scroll');
var $tip = $('.scroll-tip');
var $close = $('.scroll-tip__close-btn');
var e_top = void 0;
var show = true;

if ($scrollbar.length) {
	e_top = $scrollbar.offset().top;
}

function showTip() {
	$tip.fadeIn('fast');
}

function hideTip() {
	$tip.fadeOut('fast');
}

// ----------------------------------------
// Public
// ----------------------------------------

function initScrollbar() {
	if (!$scrollbar) {
		return false;
	}

	if ($(window).width() > 1023) {
		return false;
	}

	$scrollbar.mCustomScrollbar({
		axis: 'x',
		scrollbarPosition: 'inside',
		theme: 'rounded-dark',
		advanced: {
			updateOnSelectorChange: 'table'
		},
		callbacks: {
			onOverflowXNone: function onOverflowXNone() {
				console.log('Horizontal scrolling is not required');
			},
			onCreate: function onCreate() {
				console.log('Plugin markup generated');
			},
			onOverflowX: function onOverflowX() {
				console.log('Horizontal scrolling required');
			}
		}
	});
}

function scrollTip() {
	if (!show) {
		return false;
	}

	if (!$scrollbar) {
		show = false;

		return false;
	}

	if ($scrollbar.hasClass('mCS_no_scrollbar')) {
		show = false;

		return false;
	}

	var w_top = $(window).scrollTop();

	if (w_top >= e_top) {
		showTip();

		show = false;
	}

	setTimeout(function () {
		hideTip();
	}, 8000);
}

function closeTip() {
	$close.on('click', hideTip);
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.initScrollbar = initScrollbar;

/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------
// Imports
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.initPassfield = undefined;

__webpack_require__(137);

// ----------------------------------------
// Public
// ----------------------------------------

function initPassfield() {
	var $password = $('.password');

	$password.passField({
		showGenerate: false,
		acceptRate: 0,
		locale: 'pl'
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.initPassfield = initPassfield;

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------
// Imports
// ----------------------------------------

// ----------------------------------------
// Private
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});
var contentString = '<div id="content">' + '<h4 class="contact__item-name">RESET2 Sp. z o.o. </h4>' + '<p>50-504 Wrocław ul. Jesionowa 23-25</p>' + '</div>';

function setPlace(latitude, longitude) {
	var place = new window.google.maps.LatLng(latitude, longitude);

	return place;
}

// ----------------------------------------
// Public
// ----------------------------------------

function initMap() {
	if ($('#map').length) {
		var location = {
			latitude: $('#map').data('lat'),
			longitude: $('#map').data('lng')
		};

		var infowindow = new window.google.maps.InfoWindow({
			content: contentString
		});

		var map = new window.google.maps.Map(document.getElementById('map'), {
			zoom: 15,
			center: setPlace(location.latitude, location.longitude),
			scrollwheel: false
		});

		var marker = new window.google.maps.Marker({
			position: setPlace(location.latitude, location.longitude),
			map: map,
			optimized: false,
			title: ''
		});

		infowindow.open(map, marker);

		window.google.maps.event.addListener(marker, 'click', function () {
			infowindow.open(map, marker);
			return false;
		});
	}
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.initMap = initMap;

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------
// Imports
// ----------------------------------------

// ----------------------------------------
// Private
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});
var $hidden = $('.hide');
var $checkbox = $('.shop-check');
var $td = $('.shop__table-select');
var $text = $('.shop__table-text');

// ----------------------------------------
// Public
// ----------------------------------------

function toggleContent() {
	$checkbox.change(function () {
		var $show = $(this).closest('tr').find($hidden);
		var $open = $(this).closest('tr').find($td);
		var $hide = $(this).closest('tr').find($text);

		if (this.checked) {
			$hide.toggle();
			$show.slideDown('slow');
			$open.attr('colspan', 1).toggleClass('close');
		} else {
			$show.toggle();
			$hide.toggle();

			$open.attr('colspan', 4).toggleClass('close');
		}
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.toggleContent = toggleContent;

/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------
// Imports
// ----------------------------------------

// ----------------------------------------
// Private
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});
var $hidden = $('.promo-item__hidden');
var $btn = $('.promo-item__more-link');
var $text = $('.promo-item__more-text');

function toggleContent() {
	var $this = $(this);
	var $open = $this.prev($hidden);
	var text = $this.hasClass('open') ? 'Regulamin promocji' : 'Pokaż mniej';

	console.log($this, $this.prev($hidden));

	$open.slideToggle('fast');
	$this.toggleClass('open').find($text).text(text);
}

// ----------------------------------------
// Public
// ----------------------------------------

function toggleDetails() {
	$btn.on('click', toggleContent);
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.toggleDetails = toggleDetails;

/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------
// Imports
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.initCssMap = undefined;

__webpack_require__(142);

// ----------------------------------------
// Private
// ----------------------------------------

var $map = $('#map-poland');

// ----------------------------------------
// Public
// ----------------------------------------

function initCssMap() {
	$map.CSSMap({
		'size': 320,
		mapStyle: 'custom',
		tooltip: 'sticky',
		formSupport: {
			enable: true,
			inputId: '#regions',
			value: 'slug'
		}
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.initCssMap = initCssMap;

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------
// Private
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});
var $link = $('.calculator-open');
var url = void 0;
var width = void 0;
var height = void 0;

// ----------------------------------------
// Public
// ----------------------------------------

function displayWindow() {
	$link.on('click', function () {
		url = $(this).data('url');
		width = $(this).data('width');
		height = $(this).data('height');
		console.log('hhhh');

		window.open(url, 'Calculation', 'width=' + width + ', height=' + height);
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.displayWindow = displayWindow;

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Вывод "Wezom" баннера в консоли браузера
 * @module
 */

(function (window) {
	var userAgent = window.navigator.userAgent.toLowerCase();
	var staticText = 'Агенство системных интернет-решений';
	var staticUrl = '> http://wezom.com.ua/';
	var staticLine = '----------------------------';

	var isWebkit = function (ua) {
		var webkit = 'WebkitAppearance' in document.body.style;
		var notEdge = !(ua.indexOf(' edge/') > 0);

		return webkit && notEdge;
	}(userAgent);

	var isIeOrEdge = function (ua) {
		var ie = /*@cc_on!@*/false || document.documentMode; // eslint-disable-line
		var edge = ua.indexOf(' edge/') > 0;

		return ie || edge;
	}(userAgent);

	if (isIeOrEdge) {
		window.console.info(staticText);
		window.console.info(staticUrl);
		window.console.log(staticLine);
	} else if (isWebkit) {
		var title = '%c';

		for (var i = 0; i < 12; i++) {
			title += ' ';
		}

		window.console.info(staticUrl);
		window.console.log(title, 'font: 75px/100% sans-serif; background: no-repeat url(data:image/jpeg;base64,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); background-size: 100%');
	} else {
		var _window$console;

		var _title = 'WEZOM';
		var banner = '\n%c' + _title.split('').join('%c %c') + '%c\n';
		var styler = [];

		var symbol = ['font:32px/1.5 Helvetica,Arial,sans-serif', 'color:#fff', 'background-color:#bb1919', 'padding:4px 14px'].join(';');

		_title.split('').forEach(function (arg) {
			styler.push(symbol);
			styler.push('');
		});

		(_window$console = window.console).log.apply(_window$console, [banner].concat(styler));
		window.console.log(staticText);
		window.console.log(staticUrl);
		window.console.log(staticLine);
	}
})(window);

/***/ }),

/***/ 18:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Внутрення, горизотальная прокрутка элементов со стилизацией
 * @module
 */

// ----------------------------------------
// Imports
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(11);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// ----------------------------------------
// Private
// ----------------------------------------

/**
 * Внутренний namespace
 * @const {string}
 * @private
 * @sourceCode
 */
var ns = 'horizontal-scroll';

/**
 * Список собранных элементов, к кототорым применен скролл
 * @type {Array}
 * @private
 * @sourceCode
 */
var $list = [];

/**
 * Обработчик собития `scroll.${ns}`
 * @param {Event} event
 * @param {Object} event.data
 * @param {number} event.data.gap
 * @param {jQuery} event.data.$wrapper
 * @param {jQuery} event.data.$element
 * @private
 * @sourceCode
 */
function onScroll(event) {
  var $holder = $(this);
  var _event$data = event.data,
      gap = _event$data.gap,
      $wrapper = _event$data.$wrapper,
      $element = _event$data.$element;


  var holderWidth = $holder.innerWidth();
  var holderScroll = $holder.scrollLeft();
  var holderScrollOffset = holderScroll + holderWidth + gap;
  var tableWidth = $element[0].scrollWidth;

  var doClassLeft = 'removeClass';
  var doClassRight = 'removeClass';

  if (holderScroll > gap) {
    doClassLeft = 'addClass';
  }

  if (tableWidth > holderScrollOffset) {
    doClassRight = 'addClass';
  }

  $wrapper[doClassLeft](ns + '--left');
  $wrapper[doClassRight](ns + '--right');

  if ($holder.data(ns + '-synchronized') !== true) {
    $element.data(ns + '-$holders').forEach(function ($syncHolder) {
      $syncHolder.data(ns + '-synchronized', true);
      $syncHolder.scrollLeft(holderScroll);
    });
  }
  $holder.data(ns + '-synchronized', false);
}

/**
 * Обработчик собития `destroy.${ns}`
 * @param {Event} event
 * @param {Object} event.data
 * @param {jQuery} event.data.$holder
 * @private
 * @sourceCode
 */
function onDestroy(event) {
  var _$this$off$unwrap$unw;

  var $this = $(this);
  var $holder = event.data.$holder;

  var index = $list.index($holder);
  if (~index) {
    $list.splice(index, 1);
    if ($list.length === 0) {
      $(window).off('resize.' + ns, onResize);
    }
  }
  $this.off('destroy.' + ns, onDestroy).unwrap().unwrap().removeClass(ns + '__element').removeInitedKey(ns).data((_$this$off$unwrap$unw = {}, _defineProperty(_$this$off$unwrap$unw, ns + '-$holder', null), _defineProperty(_$this$off$unwrap$unw, ns + '-$holders', null), _$this$off$unwrap$unw));
}

/**
 * Обработчик собития `mousedown.${ns}`
 * @param {Event} event
 * @param {Object} event.data
 * @param {jQuery} event.data.$holder
 * @param {jQuery} event.data.$wrapper
 * @private
 * @sourceCode
 */
function onDown(event) {
  var _event$data2 = event.data,
      $holder = _event$data2.$holder,
      $wrapper = _event$data2.$wrapper;

  $wrapper.addClass(ns + '--mousedown');
  $holder.on('mousemove.' + ns, { $holder: $holder, $wrapper: $wrapper, downX: event.pageX }, onMove);
}

/**
 * Обработчик собития `mouseup.${ns}`
 * @param {Event} event
 * @param {Object} event.data
 * @param {jQuery} event.data.$holder
 * @param {jQuery} event.data.$wrapper
 * @private
 * @sourceCode
 */
function onUp(event) {
  var _event$data3 = event.data,
      $holder = _event$data3.$holder,
      $wrapper = _event$data3.$wrapper;

  $wrapper.removeClass(ns + '--mousedown');
  $holder.off('mousemove.' + ns, onMove);
}

/**
 * Обработчик собития `mousemove.${ns}`
 * @param {Event} event
 * @param {Object} event.data
 * @param {jQuery} event.data.$holder
 * @param {jQuery} event.data.$wrapper
 * @private
 * @sourceCode
 */
function onMove(event) {
  var gutter = 12;
  var _event$data4 = event.data,
      downX = _event$data4.downX,
      $holder = _event$data4.$holder,
      $wrapper = _event$data4.$wrapper;
  var x = event.pageX,
      y = event.pageY;


  var offset = $wrapper.offset();
  var left = offset.left + gutter;
  var top = offset.top + gutter;
  var right = left - gutter * 2 + $wrapper.innerWidth();
  var bottom = top - gutter * 2 + $wrapper.innerHeight();

  if (x < left || x > right || y < top || y > bottom) {
    $holder.trigger('mouseup.' + ns);
    return false;
  }
  var scroll = $holder.scrollLeft() - (x - downX) / 2;
  $holder.scrollLeft(scroll);
}

/**
 * Обработчик собития `destroy.${ns}` для `window`
 * @private
 * @sourceCode
 */
function onResize() {
  if ($list.length) {
    $list.trigger('scroll');
  }
}

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * Оборачивание элементов и добавление прослушки на горизотальную прокрутку.
 * При инициализации каждому элементу добавляеться запись `data('horizontal-scroll', true)`
 * Для того чтобы отфильтровывать уже инициализированные элементы при возможных последующих обращениях
 *
 * Каждому элементу добавляеться CSS класс, а также оборачивается нужной разметкой
 * для стилизации и возможность устастановки прослушек.
 *
 * Пример начальной разметки
 *
 * ```markup
 * <div class="wysiwyg">
 *     <table>
 *         <!-- content -->
 *     </table>
 * </div>
 * ```
 *
 * Пример результата
 *
 * ```markup
 * <div class="wysiwyg">
 *     <div class="horizontal-scroll"> <!-- Стилизация псевдоэлементами слева и справа в зависимости от прокрутки -->
 *         <div class="horizontal-scroll__holder"> <!-- Создает прокрутку и не нем же весят события скрола -->
 *             <table class="horizontal-scroll__element">
 *                 <!-- content -->
 *             </table>
 *         </div>
 *     </div>
 * </div>
 * ```
 *
 * @example <caption>Инит таблиц</caption>
 * horizontalScroll('.wysiwyg table');
 *
 * @example <caption>Инит таблиц в текущем контейнере</caption>
 * horizontalScroll('.wysiwyg table', $currentContainer);
 *
 * @example <caption>Инит таблиц в текущем контейнере с зазором в 20 пикселей</caption>
 * horizontalScroll('.wysiwyg table', $currentContainer, 20);
 *
 * @example <caption>Инит таблиц с зазором в 20 пикселей</caption>
 * horizontalScroll('.wysiwyg table', null, 20);
 *
 * @param {string|jQuery} selector - поиск элементов по селектору или jQuery element
 * @param {jQuery} [$context=null] - контекст в котором будет выполнен поиск селектора
 * @param {number} [gap=4] - зазор для скролла (в пикселях), который определяет, когда добавлять/удалять классы стилизации
 * @sourceCode
 */
function horizontalScroll(selector) {
  var $context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var gap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 4;

  var $elements = selector && selector.jquery ? selector : $(selector, $context);

  $elements.each(function (i, el) {
    var $element = $(el);

    if ($element.hasInitedKey(ns, false)) {
      return true;
    }

    $element.addClass(ns + '__element').wrap('<div class="' + ns + '"><div class="' + ns + '__holder"></div></div>');
    horizontalScroll.init($element, gap);
  });
}

/**
 * Инициализация прослушки
 * Метод можно использовать отдельно, если у вас уже есть готовая структура разметки
 *
 * Необходимая структура
 *
 * ```markup
 * <div class="horizontal-scroll">
 *     <div class="horizontal-scroll__holder">
 *         <div class="horizontal-scroll__element">
 *             <!-- content -->
 *         </div>
 *     </div>
 * </div>
 * ```
 *
 * @example <caption>Необходимая структура</caption>
 * let $element = $('.horizontal-scroll__element);
 * horizontalScroll.init($element);
 * // horizontalScroll.init($element, 20); // => с зазором в 20 пикселей
 *
 * @param {jQuery} $element - поиск элементов по селектору
 * @param {number} [gap=3] - зазор для скролла (в пикселях), который определяет, когда добавлять/удалять классы стилизации
 * @method horizontalScroll::init
 * @inner
 */
horizontalScroll.init = function ($element) {
  var gap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;

  if ($element.hasInitedKey(ns)) {
    return true;
  }

  var $holder = $element.parent();
  var $wrapper = $holder.parent();

  $holder.on('scroll.' + ns, { gap: gap, $element: $element, $wrapper: $wrapper }, onScroll);
  $holder.on('mousedown.' + ns, { $holder: $holder, $wrapper: $wrapper }, onDown);
  $holder.on('mouseup.' + ns, { $holder: $holder, $wrapper: $wrapper }, onUp);
  $holder.on('dragstart.' + ns, function () {
    return false;
  });
  $element.on('destroy.' + ns, { $holder: $holder }, onDestroy);
  $element.data(ns + '-$holder', $holder);
  $element.data(ns + '-$holders', []);

  if ($list.length) {
    $list = $list.add($holder);
  } else {
    $list = $holder;
    $(window).on('resize.' + ns, onResize);
  }

  $holder.trigger('scroll.' + ns);
};

/**
 * Синхронизация скролов
 * __Важно!__ метод нужно вызывать после инициализации скролов для каждлго из элементов
 *
 * @example
 * let $elements = $('.elements');
 * horizontalScroll($elements);
 * horizontalScroll.sync($elements);
 *
 * @param $elements
 * @method horizontalScroll::sync
 * @inner
 * @sourceCode
 */
horizontalScroll.sync = function ($elements) {
  $elements.each(function (i, el) {
    var $el = $(el);
    var $holders = [];

    $elements.not($el).each(function (i, el) {
      $holders.push($(el).data(ns + '-$holder'));
    });

    $el.data(ns + '-$holders', $holders);
  });
};

/**
 * Удаление внутреннего скролла
 *
 * @example <caption>Удаление внутреннего скрола с таблиц в текущем контейнере</caption>
 * horizontalScroll.destroy('.wysiwyg table');
 *
 * @example <caption>Удаление внутреннего скрола с таблиц в текущем контейнере</caption>
 * horizontalScroll.destroy('.wysiwyg table', $currentContainer);
 *
 * @example <caption>Удаление внутреннего скрола с нужного элемента</caption>
 * horizontalScroll.destroy($myElement);
 *
 * @param {string|jQuery} selector - Селектор или jQuery элемент
 * @param {string} selector.jquery - Если передан элемент - строка, содержащая номер версии `jQuery` ({@link http://api.jquery.com/jquery-2/})
 * @param {jQuery} [$context=null] - контекст в котором будет выполнен поиск селектора
 * @method horizontalScroll::destroy
 * @inner
 */
horizontalScroll.destroy = function (selector) {
  var $context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (selector && selector.jquery) {
    selector.trigger('destroy.' + ns);
    return;
  }

  $(selector, $context).each(function (i, el) {
    var $element = $(el);
    $element.trigger('destroy.' + ns);
  });
};

// ----------------------------------------
// Exports
// ----------------------------------------

exports.default = horizontalScroll;

/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Оборачивание элементов для пропорцинальной адаптации
 * @module
 */

// ----------------------------------------
// Imports
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});

__webpack_require__(11);

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * @param {string} [selector=".js-form"]- поиск элементов по селектору
 * @param {jQuery} [$context=null] - контекст в котором будет выполнен поиск селектора
 * @sourceCode
 */
function wrapMedia(selector) {
	var $context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	var $elements = selector && selector.jquery ? selector : $(selector, $context);
	$elements.each(function (i, el) {
		var $el = $(el);
		if ($el.hasInitedKey('wrap-media', false)) {
			return true;
		}

		var width = parseInt($el.attr('width') || $el[0].offsetWidth);
		var height = parseInt($el.attr('height') || $el[0].offsetHeight);
		var ratio = parseFloat((height / width * 100).toFixed(2));

		$el.unwrap('p').wrap('\n\t\t<div class="ratio-wrapper" style="max-width:' + width + 'px;margin-left:auto;margin-right:auto;">\n\t\t\t<div class="ratio" style="padding-top:' + ratio + '%;"></div>\n\t\t</div>\n\t\t');

		console.log($el);
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.default = wrapMedia;

/***/ }),

/***/ 20:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Инит валидации форм
 * @module
 */

// ----------------------------------------
// Imports
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});

__webpack_require__(11);

__webpack_require__(17);

__webpack_require__(21);

__webpack_require__(49);

var _phoneMask = __webpack_require__(50);

var _phoneMask2 = _interopRequireDefault(_phoneMask);

var _formMessage = __webpack_require__(52);

var _loadItems = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------
// Private
// ----------------------------------------

/**
 * Параметры по умолчанию
 * @const {Object}
 * @private
 */

// import Preloader from './preloader';
var configDefault = {
	ignore: ':hidden, .js-ignore',
	errorClass: 'has-error',
	validClass: 'is-valid',
	get classes() {
		return {
			error: this.errorClass,
			valid: this.validClass,
			labelError: 'label-error',
			formError: 'form--error',
			formValid: 'form--valid',
			formPending: 'form--pending'
		};
	},

	onfocusout: function onfocusout(element) {
		this.element(element);
	},
	highlight: function highlight(element) {
		element.classList.remove(this.settings.classes.valid);
		element.classList.add(this.settings.classes.error);

		if ($(element).hasClass('select')) {
			$(element).nextAll('.select2').find('.select2-selection').addClass(this.settings.classes.error);
		}
	},
	unhighlight: function unhighlight(element) {
		element.classList.remove(this.settings.classes.error);
		element.classList.add(this.settings.classes.valid);

		if ($(element).hasClass('select')) {
			$(element).nextAll('.select2').find('.select2-selection').removeClass(this.settings.classes.error);
		}
	},
	submitHandler: function submitHandler(form) {
		var $form = $(form);
		var actionUrl = $form.data('ajax');
		if (typeof actionUrl !== 'string') {
			window.alert(['Error!', '--------------------', 'ajax обработчик не указан'].join('\n'));
			return;
		}

		// let preloader = new Preloader($form);
		// preloader.show();

		var formData = new window.FormData();
		formData.append('xhr-lang', $('html').attr('lang') || 'ru');

		// игнорируемые типы инпутов
		var ignoredInputsType = ['submit', 'reset', 'button', 'image'];

		$form.find('input, textarea, select').each(function (i, element) {
			var value = element.value,
			    type = element.type;

			if (~ignoredInputsType.indexOf(type)) {
				return true;
			}

			var $element = $(element);
			var elementNode = $element.nodeName();
			var elementName = $element.data('name') || $element.attr('name') || null;

			if (elementName === null) {
				return true;
			}

			switch (elementNode) {
				case 'input':
					if (type === 'file') {
						element.files.forEach(function (file) {
							formData.append(file.name, file);
						});
					} else {
						if (type === 'checkbox' && !element.checked) {
							console.log(element);

							break;
						}
						formData.append(elementName, value);
					}
					break;

				case 'textarea':
					formData.append(elementName, value);
					break;

				case 'select':
					var multiName = /\[\]$/;
					if (multiName.test(elementName) || element.multiple) {
						elementName = elementName.replace(multiName, '');
						value.forEach(function (val) {
							formData.append(elementName, val);
						});
					} else {
						formData.append(elementName, value);
					}
					break;
			}
		});

		var xhrUrl = window.B2FAPI.paths.forms + actionUrl;
		var xhr = new window.XMLHttpRequest();

		xhr.open('POST', xhrUrl);
		xhr.onreadystatechange = function () {
			if (xhr.readyState === 4) {
				getResponse($form, xhr);
			}
		};
		xhr.send(formData);
		return false;
	}
};

/**
 * Обработка ответа от сервера
 * @param {jQuery} $form
 * @param {Object} xhr
 * @param {number} xhr.status
 * @param {string} xhr.statusText
 * @param {Object|string} xhr.response
 * @param {string} [xhr.response.redirect] - урл для редиректа, если равен текущему урлу - перегражаем страницу
 * @param {boolean} [xhr.response.reload] - перегрузить страницу
 * @param {boolean} [xhr.response.reset] - сбросить форму
 * @param {Array} [xhr.response.clear] - сбросить форму
 * @private
 */
function getResponse($form, xhr) {
	var status = xhr.status,
	    statusText = xhr.statusText,
	    response = xhr.response;
	// let {preloader} = $form.data();

	// все плохо

	if (status !== 200) {
		console.log(xhr);
		window.alert(['Error!', 'status: ' + status, '--------------------', statusText].join('\n'));
		return false;
	}

	// обрабатываем ответ
	// ------------------

	if (typeof response === 'string') {
		response = JSON.parse(response);
	}

	if (response.reload || window.location.href === response.redirect) {
		return window.location.reload();
	}

	if (response.redirect) {
		return window.location.href = response.redirect;
	}

	if (response.success) {
		if (response.message) {
			(0, _formMessage.formMessage)(response.message);
		}

		if (response.html) {
			(0, _loadItems.loadFilterItems)(response.html);
		}

		if (response.clear) {
			if (Array.isArray(response.clear)) {
				response.clear.forEach(function (clearSelector) {
					$form.find(clearSelector).val('');
				});
			} else {
				// игнорируемые типы инпутов
				var ignoredInputsType = ['submit', 'reset', 'button', 'image'];
				$form.find('input, textarea, select').each(function (i, element) {
					if (~ignoredInputsType.indexOf(element.type)) {
						return true;
					}
					element.value = '';
				});
			}
		} else if (response.reset) {
			$form.trigger('reset');
		}

		// preloader.hide();
	}
}

/**
 * Пользовательские обработчики формы
 * @param {jQuery} $form
 * @param {Object} Validator {@link https://jqueryvalidation.org/?s=validator}
 * @param {Function} Validator.resetForm {@link https://jqueryvalidation.org/Validator.resetForm/}
 */
function setHandlers($form, Validator) {
	// сброс формы
	$form.on('reset', function () {
		return Validator.resetForm();
	});

	// дальше ваш код
}

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * @param {string} [selector=".js-form"]- поиск элементов по селектору
 * @param {jQuery} [$context=null] - контекст в котором будет выполнен поиск селектора
 * @sourceCode
 */
function validation(selector) {
	var $context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	var $forms = selector && selector.jquery ? selector : $(selector, $context);
	$forms.each(function (i, el) {
		var $form = $(el);
		if ($form.hasInitedKey('validator', false)) {
			return true;
		}

		var configUser = $form.data('validation-config') || {};
		var configCurrent = $.extend(true, configDefault, configUser);

		(0, _phoneMask2.default)('[data-phone-mask]', $form);
		$form.validate(configCurrent);
		setHandlers($form, $form.data('validator'));
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.default = validation;

/***/ }),

/***/ 22:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------
// Private
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});
var url = window.B2FAPI.ajax.printouts;
var $loadBtn = $('#show-more-printouts');
var $preloader = $('.preloader');
var $container = $('.printouts__items-block');
var $filtersContainer = $('.partners-block');
var page = void 0;
var productId = void 0;

// ----------------------------------------
// Public
// ----------------------------------------

function loadItems() {
	$loadBtn.on('click', function () {
		page = $(this).data('page');
		productId = $(this).data('product-id');
		$(this).data('page', page + 1);

		$.ajax({
			type: 'post',
			dataType: 'JSON',
			url: url,
			data: {
				page: page,
				productId: productId
			},

			beforeSend: function beforeSend() {
				$preloader.fadeIn();
			},

			success: function success(data) {
				page = data.page;

				$container.append(data.html);

				if (data.last) {
					$loadBtn.remove();
				}
			},
			complete: function complete() {
				$preloader.delay(300).fadeOut('fast');
			}
		});
	});
}

function loadFilterItems(html) {
	$preloader.fadeIn();

	$filtersContainer.html(html);

	$preloader.delay(300).fadeOut('fast');
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.loadItems = loadItems;
exports.loadFilterItems = loadFilterItems;

/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * @fileOverview Основной файл инициализации модулей
 */

// ----------------------------------------
// Imports
// ----------------------------------------

__webpack_require__(39);

__webpack_require__(44);

__webpack_require__(45);

__webpack_require__(46);

__webpack_require__(47);

var _horizontalScroll = __webpack_require__(18);

var _horizontalScroll2 = _interopRequireDefault(_horizontalScroll);

var _wrapMedia = __webpack_require__(19);

var _wrapMedia2 = _interopRequireDefault(_wrapMedia);

var _validation = __webpack_require__(20);

var _validation2 = _interopRequireDefault(_validation);

var _magnificPopup = __webpack_require__(53);

var _sliders = __webpack_require__(122);

var _header = __webpack_require__(124);

var _mobileMenu = __webpack_require__(125);

var _spincrement = __webpack_require__(127);

var _sidebar = __webpack_require__(129);

var _select = __webpack_require__(130);

var _scrollbar = __webpack_require__(132);

var _passField = __webpack_require__(136);

var _map = __webpack_require__(138);

var _tables = __webpack_require__(139);

var _promo = __webpack_require__(140);

var _cssMap = __webpack_require__(141);

var _loadItems = __webpack_require__(22);

var _openWindow = __webpack_require__(143);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import {previewer} from './_modules/_preview';
//
// if (IS_FTP || !IS_PRODUCTION) {
// 	previewer();
// }

// ----------------------------------------
// Public
// ----------------------------------------

window.jQuery(document).ready(function ($) {
	(0, _horizontalScroll2.default)('.wysiwyg table');
	(0, _wrapMedia2.default)('.wysiwyg iframe, .wysiwyg video');
	(0, _validation2.default)('.js-form');
	(0, _magnificPopup.mfpAjax)('.js-mfp-ajax');
	(0, _magnificPopup.mfpInline)();
	(0, _magnificPopup.mfpGallery)();
	(0, _sliders.mainSlider)();
	(0, _sliders.firmsSlider)();
	(0, _header.headerSearch)();
	(0, _mobileMenu.mobileMenu)();
	(0, _header.setPaddingTop)();
	(0, _header.headerLang)();
	(0, _spincrement.spincrementNum)();
	(0, _sidebar.subMenuToggle)('.sidebar__menu-link--child', '.sidebar__menu-item--child', '.sidebar__sub-menu');
	(0, _scrollbar.initScrollbar)();
	(0, _select.initSelect)();
	(0, _passField.initPassfield)();
	(0, _map.initMap)();
	(0, _tables.toggleContent)();
	(0, _promo.toggleDetails)();
	(0, _header.loginToggle)();
	(0, _cssMap.initCssMap)();
	(0, _loadItems.loadItems)();
	(0, _sliders.reviewsSlider)();
	(0, _mobileMenu.filterMenu)();
	(0, _openWindow.displayWindow)();

	if (!$.trim($('.news-item__date-wrap').html()).length) {
		$('.news-item__date-wrap').remove();
	}
});

window.jQuery(window).on('scroll', function () {
	(0, _header.fixedHeader)();
});

if (true) {
	__webpack_require__(144);
}

/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Инит плгина lozad.js
 * @module
 * @see {@link https://github.com/ApoorvSaxena/lozad.js}
 */

// ----------------------------------------
// Imports
// ----------------------------------------

__webpack_require__(17);

// ----------------------------------------
// Private
// ----------------------------------------

/**
 * Добавлеям `lazyLoad` к глобальныму объекту `window`
 */
function createLazyLoad() {
	var lozad = __webpack_require__(48);
	window.lazyLoad = lozad('.lozad', {
		load: function load(el) {
			var $el = $(el);
			var src = $el.data('src');

			if ($el.nodeName() === 'img') {
				$el.attr('src', src);
			} else {
				$el.css('background-image', 'url(' + src + ')');
			}

			var $parent = $el.parent('.lazy-load');
			if (!$parent.length) {
				$parent = $el;
			}
			setTimeout(function () {
				return $parent.addClass('is-ready');
			}, 50);
		}
	});
	window.lazyLoad.observe();
}

// ----------------------------------------
// Public
// ----------------------------------------

(function ($) {
	if (!$('.lozad').length) {
		return false;
	}

	// если уже `lazyLoad` добавлен вызываем
	if (window.lazyLoad) {
		return window.lazyLoad.observe();
	}

	// иначе добавляем
	if (window.Modernizr.intersectionobserver) {
		createLazyLoad();
	} else {
		// грузим асинхронно полифилл если не поддерживается Intersection Observer
		__webpack_require__.e/* require.ensure */(0).then((function () {
			__webpack_require__(145);
			createLazyLoad();
		}).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
	}
})(window.jQuery);

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Расширение библиотеки валидации
 * @module
 */

// ----------------------------------------
// Private
// ----------------------------------------

/**
 * Получение имени типа
 * @param {string} type
 * @return {string}
 * @private
 */

function formGetTypeName(type) {
	var typeName = void 0;
	switch (type) {
		case 'select-one':
		case 'select-multiple':
			typeName = '_select';
			break;
		case 'radio':
		case 'checkbox':
			typeName = '_checker';
			break;
		default:
			typeName = '';
	}
	return typeName;
}

/**
 * Получение сообщения в зависимости от элемента
 * @param {HTMLElement} element
 * @param {string} method
 * @return {string}
 * @private
 */
function formGetMethodMsgName(element, method) {
	var value = element.value;
	var methodName = void 0;
	switch (method) {
		case 'required':
		case 'maxlength':
		case 'minlength':
		case 'rangelength':
			methodName = method + formGetTypeName(element.type);
			break;
		case 'password':
			if (/^(\s|\t)*/.test(value)) {
				methodName = method + '_space';
			} else {
				methodName = method;
			}
			break;
		case 'url':
			if (!/^(http(s)?:)?\/\//i.test(value)) {
				methodName = method + '_protocol';
			} else if (!/((?!\/).)\..*$/.test(value)) {
				methodName = method + '_domen';
			} else if (!/\..{2,}$/.test(value)) {
				methodName = method + '_domen-length';
			} else {
				methodName = method;
			}
			break;
		case 'email':
			if (/(@\.|\.$)/.test(value)) {
				methodName = method + '_dot';
			} else if (/@.*(\\|\/)/.test(value)) {
				methodName = method + '_slash';
			} else if (!/@/.test(value)) {
				methodName = method + '_at';
			} else if (/^@/.test(value)) {
				methodName = method + '_at-start';
			} else if (value.split('@').length > 2) {
				methodName = method + '_at-multiple';
			} else if (/@$/.test(value)) {
				methodName = method + '_at-end';
			} else {
				methodName = method;
			}
			break;
		default:
			methodName = method;
	}
	return methodName;
}

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * Объект расширений
 * @const {Object}
 */
var extendConfig = {
	/**
  * Прототипы плагина
  * @var {Object} messages
  * @sourceCode |+30
  */
	get messages() {
		var translates = window.jsTranslations && window.jsTranslations.validation || {};

		for (var key in translates) {
			var value = translates[key];

			switch (key) {
				case 'maxlength':
				case 'maxlength_checker':
				case 'maxlength_select':
				case 'minlength':
				case 'minlength_checker':
				case 'minlength_select':
				case 'rangelength':
				case 'rangelength_checker':
				case 'rangelength_select':
				case 'range':
				case 'min':
				case 'max':
				case 'filetype':
				case 'filesize':
				case 'filesizeEach':
				case 'pattern':
					translates[key] = $.validator.format(value);
					break;
			}
		}

		return translates;
	},

	/**
  * Прототипы плагина
  * @var {Object} prototype
  */
	prototype: {
		/**
   * Вывод дефолтных сообщений
   * @param {Element} element
   * @param {Object|string} rule
   * @return {string}
   * @method prototype::defaultMessage
   */
		defaultMessage: function defaultMessage(element, rule) {
			if (typeof rule === 'string') {
				rule = { method: rule };
			}

			var message = this.findDefined(this.customMessage(element.name, rule.method), this.customDataMessage(element, rule.method), !this.settings.ignoreTitle && element.title || undefined, // eslint-disable-line no-mixed-operators
			$.validator.messages[formGetMethodMsgName(element, rule.method)], '<strong>Warning: No message defined for ' + element.name + '</strong>');

			var pattern = /\$?\{(\d+)\}/g;

			if (typeof message === 'function') {
				message = message.call(this, rule.parameters, element);
			} else if (pattern.test(message)) {
				message = $.validator.format(message.replace(pattern, '{$1}'), rule.parameters);
			}

			return message;
		}
	},

	/**
  * Методы валидации
  * @var {Object} methods
  */
	methods: {
		/**
   * Валидация email
   * @param {string} value
   * @param {Element} element
   * @param {Object} param
   * @return {boolean}
   * @method methods::email
   * @sourceCode |+4
   */
		email: function email(value, element) {
			var pattern = /^(([a-zA-Z0-9&+-=_])+((\.([a-zA-Z0-9&+-=_]){1,})+)?){1,64}@([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,6}$/;
			return this.optional(element) || pattern.test(value);
		},


		/**
   * Валидация паролей
   * @param {string} value
   * @param {Element} element
   * @param {Object} param
   * @return {boolean}
   * @method methods::password
   * @sourceCode |+3
   */
		password: function password(value, element) {
			return this.optional(element) || /^\S.*$/.test(value);
		},


		/**
   * Проверка общего объема всех файла в KB
   * @param {string} value
   * @param {Element} element
   * @param {Object} param
   * @return {boolean}
   * @method methods::filesize
   * @sourceCode |+7
   */
		filesize: function filesize(value, element, param) {
			var kb = 0;
			for (var i = 0; i < element.files.length; i++) {
				kb += element.files[i].size;
			}
			return this.optional(element) || kb / 1024 <= param;
		},


		/**
   * Максимальное количество файлов для загрузки
   * @param {string} value
   * @param {Element} element
   * @param {Object} param
   * @return {boolean}
   * @method methods::maxupload
   * @sourceCode |+3
   */
		maxupload: function maxupload(value, element, param) {
			return element.files.length <= param;
		},


		/**
   * Проверка объема каждого файла в KB
   * @param {string} value
   * @param {Element} element
   * @param {Object} param
   * @return {boolean}
   * @method methods::filesizeeach
   * @sourceCode |+10
   */
		filesizeeach: function filesizeeach(value, element, param) {
			var flag = true;
			for (var i = 0; i < element.files.length; i++) {
				if (element.files[i].size / 1024 > param) {
					flag = false;
					break;
				}
			}
			return this.optional(element) || flag;
		},


		/**
   * Проверка типа файла по расширению
   * @param {string} value
   * @param {Element} element
   * @param {Object} param
   * @return {boolean}
   * @method methods::filetype
   * @sourceCode |+25
   */
		filetype: function filetype(value, element, param) {
			var result = void 0;
			var extensions = 'png|jpe?g|doc|pdf|gif|zip|rar|tar|html|swf|txt|xls|docx|xlsx|odt';
			if (element.files.length < 1) {
				return true;
			}

			param = typeof param === 'string' ? param.replace(/,/g, '|') : extensions;
			if (element.multiple) {
				var files = element.files;
				for (var i = 0; i < files.length; i++) {
					var _value = files[i].name;
					var valueMatch = _value.match(new RegExp('.(' + param + ')$', 'i'));

					result = this.optional(element) || valueMatch;
					if (result === null) {
						break;
					}
				}
			} else {
				var _valueMatch = value.match(new RegExp('\\.(' + param + ')$', 'i'));
				result = this.optional(element) || _valueMatch;
			}
			return result;
		},


		/**
   * Проверка валидности одного из указанных элементов
   * _этот или другой - должен быть валидным_
   * @param {string} value
   * @param {Element} element
   * @param {Object} param
   * @return {boolean}
   * @method methods::or
   * @sourceCode |+4
   */
		or: function or(value, element, param) {
			var $module = $(element).parents('.js-form');
			return $module.find(param + ':filled').length;
		},


		/**
   * Проверка валидности слов (чаще всего используется для имени или фамилии)
   * @param {string} value
   * @param {Element} element
   * @return {boolean}
   * @method methods::word
   * @sourceCode |+4
   */
		word: function word(value, element) {
			var testValue = /^[a-zA-Zа-яА-ЯіІїЇєёЁЄґҐĄąĆćĘęŁłŃńÓóŚśŹźŻż\'\`\- ]*$/.test(value); // eslint-disable-line no-useless-escape
			return this.optional(element) || testValue;
		},


		/**
   * Проверка валидности логинов
   * @param {string} value
   * @param {Element} element
   * @param {Object} param
   * @return {boolean}
   * @method methods::login
   * @sourceCode |+4
   */
		login: function login(value, element) {
			var testValue = /^[0-9a-zA-Zа-яА-ЯіІїЇєЄёЁґҐ][0-9a-zA-Zа-яА-ЯіІїЇєЄґҐĄąĆćĘęŁłŃńÓóŚśŹźŻż\-\._]+$/.test(value); // eslint-disable-line no-useless-escape
			return this.optional(element) || testValue;
		},


		/**
   * Валидация номера телефона (укр)
   * @param {string} value
   * @param {Element} element
   * @return {boolean}
   * @method methods::phoneua
   * @sourceCode |+3
   */
		phoneua: function phoneua(value, element) {
			return this.optional(element) || /^(((\+?)(38))\s?)?(([0-9]{3})|(\([0-9]{3}\)))(\-|\s)?(([0-9]{3})(\-|\s)?([0-9]{2})(\-|\s)?([0-9]{2})|([0-9]{2})(\-|\s)?([0-9]{2})(\-|\s)?([0-9]{3})|([0-9]{2})(\-|\s)?([0-9]{3})(\-|\s)?([0-9]{2}))$/.test(value); // eslint-disable-line no-useless-escape
		},


		/**
   * Валидация номера телефона (общая)
   * @param {string} value
   * @param {Element} element
   * @param {Object} param
   * @return {boolean}
   * @method methods::phone
   * @sourceCode |+3
   */
		phone: function phone(value, element) {
			return this.optional(element) || /^(((\+?)(\d{1,3}))\s?)?(([0-9]{0,4})|(\([0-9]{3}\)))(\-|\s)?(([0-9]{3})(\-|\s)?([0-9]{2})(\-|\s)?([0-9]{2})|([0-9]{2})(\-|\s)?([0-9]{2})(\-|\s)?([0-9]{3})|([0-9]{2})(\-|\s)?([0-9]{3})(\-|\s)?([0-9]{2}))$/.test(value); // eslint-disable-line no-useless-escape
		},
		postal: function postal(value, element) {
			return this.optional(element) || /^(\d{2}-\d{3})$/.test(value); // eslint-disable-line no-useless-escape
		},

		/**
   * Проверки пробелов в значении
   * @param {string} value
   * @return {boolean}
   * @method methods::nospace
   * @sourceCode |+4
   */
		nospace: function nospace(value) {
			var str = value.replace(/\s|\t|\r|\n/g, '');
			return str.length > 0;
		},


		/**
   * Проверки валидности элемента
   * @param {string} value
   * @param {Element} element
   * @return {boolean}
   * @method methods::validTrue
   * @sourceCode |+3
   */
		validdata: function validdata(value, element) {
			return $(element).data('valid') === true;
		}
	}
};

for (var key in extendConfig) {
	$.extend($.validator[key], extendConfig[key]);
}

/***/ }),

/***/ 50:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Инит inputmask для телефонов
 * @module
 */

// ----------------------------------------
// Imports
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});

__webpack_require__(51);

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * @param {string} [selector=".js-form"]- поиск элементов по селектору
 * @param {jQuery} [$context=null] - контекст в котором будет выполнен поиск селектора
 * @sourceCode
 */
function phoneMask(selector) {
	var $context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	var $inputs = selector && selector.jquery ? selector : $(selector, $context);
	$inputs.each(function (i, el) {
		var $input = $(el);
		if ($input.hasInitedKey('inputmask-inited')) {
			return true;
		}

		var mask = $input.data('phoneMask') || '+38(999) 99-99-999';
		$input.inputmask({
			mask: mask,
			androidHack: window.Modernizr.android,
			disablePredictiveText: window.Modernizr.android,
			oncomplete: function oncomplete() {
				$input.data('valid', true);
			},
			onincomplete: function onincomplete() {
				$input.data('valid', false);
			}
		}).on('change.isComplete', function () {
			$input.data('valid', $input.inputmask('isComplete'));
		});
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.default = phoneMask;

/***/ }),

/***/ 52:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// ----------------------------------------
// Imports
// ----------------------------------------

// ----------------------------------------
// Private
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});
var url = window.B2FAPI.paths.thank;

// ----------------------------------------
// Public
// ----------------------------------------

function formMessage(msg) {
	$.magnificPopup.open({
		items: {
			src: url
		},
		type: 'ajax',
		removalDelay: 300,
		mainClass: 'zoom-in',
		closeMarkup: '<button class="mfp-close" id="custom-close-ajax"></button>',
		callbacks: {
			ajaxContentAdded: function ajaxContentAdded() {
				$('.thank-popup__text').text(msg);
			}
		}
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.formMessage = formMessage;

/***/ }),

/***/ 53:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Инициализация плагина Magnific Popup
 * @module
 * @see {@link http://dimsemenov.com/plugins/magnific-popup/documentation.html}
 */

// ----------------------------------------
// Imports
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.mfpInline = exports.mfpGallery = exports.mfpAjax = undefined;

__webpack_require__(54);

var _merge = __webpack_require__(55);

var _merge2 = _interopRequireDefault(_merge);

var _validation = __webpack_require__(20);

var _validation2 = _interopRequireDefault(_validation);

var _horizontalScroll = __webpack_require__(18);

var _horizontalScroll2 = _interopRequireDefault(_horizontalScroll);

var _wrapMedia = __webpack_require__(19);

var _wrapMedia2 = _interopRequireDefault(_wrapMedia);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------
// Private
// ----------------------------------------

// переводы для плагина
(function ($) {
	var jsTranslations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	var mfp = jsTranslations.mfp;

	if (!mfp) {
		return false;
	}

	$.extend(true, $.magnificPopup.defaults, {
		tClose: mfp.tClose,
		tLoading: mfp.tLoading,
		gallery: {
			tPrev: mfp.tPrev,
			tNext: mfp.tNext,
			tCounter: mfp.tCounter
		},
		image: {
			tError: mfp.tErrorImage
		},
		ajax: {
			tError: mfp.tError
		},
		inline: {
			tNotFound: mfp.tNotFound
		}
	});
})(window.jQuery, window.jsTranslations);

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * @param {string} [selector=".js-form"]- поиск элементов по селектору
 * @param {Object} [userConfig={}] - пользовательский конфиг
 * @param {jQuery} [$wrapper=$('body')] - контекст в котором будет выполнен поиск селектора
 * @sourceCode
 */
function mfpAjax() {
	var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.js-mfp-ajax';
	var userConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	var $wrapper = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $('body');

	var config = (0, _merge2.default)({
		mainClass: 'zoom-in',
		type: 'ajax',
		delegate: selector,
		removalDelay: 300,
		closeMarkup: '<button class="mfp-close" id="custom-close-ajax"></button>',
		callbacks: {
			elementParse: function elementParse(item) {
				var _item$el$data = item.el.data(),
				    url = _item$el$data.url,
				    _item$el$data$type = _item$el$data.type,
				    type = _item$el$data$type === undefined ? 'POST' : _item$el$data$type,
				    _item$el$data$param = _item$el$data.param,
				    data = _item$el$data$param === undefined ? {} : _item$el$data$param;

				this.st.ajax.settings = { url: url, type: type, data: data };
			},
			ajaxContentAdded: function ajaxContentAdded() {
				var $container = this.contentContainer || [];
				if ($container) {
					(0, _horizontalScroll2.default)('.wysiwyg table', $container);
					(0, _wrapMedia2.default)('.wysiwyg iframe, .wysiwyg video', $container);
					(0, _validation2.default)('.js-form', $container);
				}
			}
		}
	}, userConfig);

	$wrapper.magnificPopup(config);
}

function mfpInline() {
	$('.js-mfp-inline').each(function () {
		$(this).magnificPopup({
			type: 'inline',
			closeBtnInside: 'false',
			removalDelay: 300,
			mainClass: 'mfp-fade',
			closeMarkup: '<button class="mfp-close" id="custom-close-ajax"></button>'
		});
	});
}

function mfpGallery() {
	$('.popup-gallery').each(function () {
		$(this).magnificPopup({
			delegate: 'a',
			type: 'image',
			closeBtnInside: 'true',
			removalDelay: 200,
			mainClass: 'mfp-with-zoom',
			image: {
				verticalFit: true,
				titleSrc: function titleSrc(item) {
					console.log($(item).closest('.review-img-item').find('.review__text').text(), item.el.closest('.review-img-item').find('.review__text').text());
					return item.el.closest('.review-img-item').find('.review__text').text();
				}
			},
			zoom: {
				enabled: true,
				duration: 300
			},
			gallery: {
				enabled: true,
				navigateByImgClick: true,
				arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%" id="custom-arrow-%dir%"></button>'
			},
			callbacks: {
				beforeOpen: function beforeOpen() {
					$('body').css('overflow', 'hidden');
				},
				beforeClose: function beforeClose() {
					$('body').css('overflow', 'auto');
				}
			}
		});
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.mfpAjax = mfpAjax;
exports.mfpGallery = mfpGallery;
exports.mfpInline = mfpInline;

/***/ })

},[38]);


// WEBPACK FOOTER //
// initialize.js